import { View } from "@/components/ui";
import { HeroSection } from "./hero-section";
import { GetTheApp } from "@/containers/get-the-app";
import { Column, Container } from "@/components/ui/layout";
import { ClaimRewardBanner } from "@/containers/banners/claim-reward";
import { getPlatform } from "@/lib/utils";
import { PromoPopup } from "@/components/shared/promo-popup";
import { UnratedVisitWidget } from "@/components/shared/visits/unrated-visit-widget";
import { RecommendedServices } from "@/components/shared/recommended-services";
import { Promos } from "./promos";
import { VisitDetailContainer } from "../visits/visit-detail";
import { AccountMyReferralBanner } from "../profile/account-my-referral/account-my-referral-banner";
import { useComponentWidth } from "@/components/hooks/use-component-width";
import { AuthReminder } from "./auth-reminder";

export function Homepage() {
  const isWeb = getPlatform() === "web";
  const { width, onLayout, ref } = useComponentWidth();
  return (
    <Container>
      <Column desktop="8">
        <View className="pt-0 md:pt-10" onLayout={onLayout} ref={ref}>
          <PromoPopup />
          <VisitDetailContainer />
          <HeroSection />
          <View className="mx-4 my-4 flex flex-col gap-4 md:mx-0">
            <AccountMyReferralBanner />
            <RecommendedServices />
            <ClaimRewardBanner />
            <Promos />
          </View>
          {isWeb && <AuthReminder width={width} />}
        </View>
      </Column>
      <Column desktop="4">
        <View className="hidden md:block md:pt-10">
          <GetTheApp />
          {isWeb && <UnratedVisitWidget />}
        </View>
      </Column>
    </Container>
  );
}
